export const TOGGLE_SELECTED_PERMISSION = 'TOGGLE_SELECTED_PERMISSION';
export const TOGGLE_SELECTED_PERMISSIONS = 'TOGGLE_SELECTED_PERMISSIONS';
export const INIT_PERMISSIONS_SELECTION = 'INIT_PERMISSIONS_SELECTION';


// WEBPACK FOOTER //
// ./src/core/services/roles/action-types.js